
const DeletionFirmness = {
  SOFT: 'deletion-firmness-soft',
  HARD: 'deletion-firmness-hard',
};

export default DeletionFirmness;
